'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const fastdom=require('fastdom');

const AppMinimumWidth=1024;
const HorizontalPadding=80;
const ViewportDesiredWidth=AppMinimumWidth+HorizontalPadding;






if(_.allExist(angular,document,window)){
angular.element(window).on('load',function(event){
fastdom.mutate(function(){return _updateViewportScaling(window,[document],event)});
});
}let

ResizeDirective=function(){function ResizeDirective(){_classCallCheck(this,ResizeDirective)}ResizeDirective.prototype.




factory=function factory($window,$document){
const _debouncedResize=_.debounce(function(event,scope){
fastdom.mutate(function(){
_updateViewportScaling($window,$document,event);
scope.$broadcast('resize::resize',{event:event});
});
},200);

const _window=angular.element($window);

return{
restrict:'A',
link:function(scope){
_window.on('resize',function(event){return _debouncedResize(event,scope)});
}};

};_createClass(ResizeDirective,null,[{key:'type',get:function(){return'directive'}}]);return ResizeDirective}();


function _getNonZeroValueFrom(obj,subkey){
let val=_.get(obj,subkey);
if(val===0){
return;
}
return val;
}


function _tryGetRealWidth($window,$document,event){
let possibleValues=[
_getNonZeroValueFrom(event,'target.outerWidth'),
_getNonZeroValueFrom(event,'currentTarget.outerWidth'),
_getNonZeroValueFrom($window,'outerWidth'),
_getNonZeroValueFrom($window,'document.documentElement.clientWidth'),
_getNonZeroValueFrom($window,'document.body.clientWidth'),
_getNonZeroValueFrom($window,'innerWidth'),
$($window).outerWidth(!0),
$($window).width(),
_getNonZeroValueFrom($window,'screen.width')];


return _(possibleValues).compact().min();
}

function _isApproximately(val,target,maxDistance){
return val===target||val>=target-maxDistance&&val<=target+maxDistance;
}

let viewportMetaTag;
function _updateViewportScaling($window,$document,event){
if(!_.exists(viewportMetaTag)){
viewportMetaTag=angular.element($document).find('meta[name="viewport"]');

if(!_.exists(viewportMetaTag))
return;
}

let currentScale=+viewportMetaTag.attr('content').split('initial-scale=')[1].split(',')[0];
let currentWidth=_tryGetRealWidth($window,$document,event);

if(currentWidth>=ViewportDesiredWidth||
_isApproximately(currentWidth,ViewportDesiredWidth,1)||
_isApproximately(currentWidth/currentScale,ViewportDesiredWidth,1)){
return;
}

let expectedScale=currentWidth<ViewportDesiredWidth?currentWidth/ViewportDesiredWidth:1;
let expectedContentValue=`width=device-width,initial-scale=${expectedScale},minimum-scale=${expectedScale},user-scalable=1`;
if(viewportMetaTag.attr('content')!==expectedContentValue){
viewportMetaTag.attr('content',expectedContentValue);
}
}

module.exports=ResizeDirective;
module.exports.prototype.factory.$inject=['$window','$document'];
//# sourceMappingURL=resizeDirective.js.map
